import MainLayout from 'components/mainLayout';

function App() {
  return <MainLayout />;
}

export default App;
